import Vue from "vue";
import VueRouter from "vue-router";

import routes from "./routes";
import store from "./store";
import { updateTitle } from "./tools";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history"
});
router.beforeEach((to, from, next) => {
  // clear search query when entering another page from search results
  if (store.getters.searchQuery.length > 0) {
    store.commit("clearSearch");
  }
  next();
});
router.afterEach(to => {
  updateTitle(to);
});

// TODO: add global route guard to check user's expiresAt and trigger logout if expired

export default router;
